/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

import {TARGETING_IMPORTS} from './targeting-imports';
import {TargetSuperSummaryComponent} from './target-super-summary.component';
import {TargetSummaryComponent} from './target-summary.component';

@Component({
  imports: [...TARGETING_IMPORTS, TargetSuperSummaryComponent, TargetSummaryComponent],
  selector: 'adn-target-summary-wrapper',
  template: `
    <adn-target-summary *ngIf="!superSummary" [targeting]="targeting" [model]="obj"></adn-target-summary>
    <adn-target-super-summary *ngIf="superSummary" [targeting]="targeting" [obj]="obj"></adn-target-super-summary>
  `
})
export class TargetSummaryWrapperComponent {
  @Input() targeting: any;
  @Input() superSummary = false;
  @Input() obj: any;
}
